export default __webpack_public_path__ + "static/media/arrow_down.829893e5.svg";